"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootReducer = createRootReducer;
exports.accessTokenReducer = accessTokenReducer;
const DebugSettings = __importStar(require("@genesys/client-core/lib/debug-settings"));
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const GraphQLEntityState = __importStar(require("@genesys/client-core/lib/graphql-entity-state"));
const redux_1 = require("redux");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const MainShell = __importStar(require("./containers/core/shell/main/index"));
const MainMenu = __importStar(require("./containers/core/shell/main-menu/index"));
const AdvancedProductSearch = __importStar(require("./containers/core/tools/advanced-product-search"));
const AirMixingTool = __importStar(require("./containers/core/tools/air-mixing-tool"));
const AirPowerTool = __importStar(require("./containers/core/tools/air-power-tool"));
const CoilProTool = __importStar(require("./containers/core/tools/coil-pro-tool"));
const Debug = __importStar(require("./containers/core/tools/debug"));
const EffectiveClaims = __importStar(require("./containers/core/tools/effective-claims"));
const FanMotorProTool = __importStar(require("./containers/core/tools/fan-motor-pro-tool"));
const FanProTool = __importStar(require("./containers/core/tools/fan-pro-tool"));
const HumidityConversionTool = __importStar(require("./containers/core/tools/humidity-conversion"));
const MlcUsageStatistics = __importStar(require("./containers/core/tools/mlc-usage-statistics"));
const Nevada = __importStar(require("./containers/core/tools/nevada"));
const OilonTool = __importStar(require("./containers/core/tools/oilon-tool"));
const PsychometricTool = __importStar(require("./containers/core/tools/psychrometric-tool"));
const SystemCompare = __importStar(require("./containers/core/tools/system-compare"));
const TandCAcceptanceStatus = __importStar(require("./containers/core/tools/t-and-c-acceptance-status"));
const TranslationSearch = __importStar(require("./containers/core/tools/translation-search"));
const UsageStatistics = __importStar(require("./containers/core/tools/usage-statistics"));
const ProductPropertySearch = __importStar(require("./containers/core/tools/validation/product-property-search"));
const ProductValidation = __importStar(require("./containers/core/tools/validation/product-validation"));
const RotorProductValidation = __importStar(require("./containers/core/tools/validation/rotor-product-validation"));
const SystemTypePropertySearch = __importStar(require("./containers/core/tools/validation/system-type-property-search"));
const SystemTypeValidation = __importStar(require("./containers/core/tools/validation/system-type-validation"));
const VariantListing = __importStar(require("./containers/core/tools/variant-listing"));
function createRootReducer() {
    return (0, redux_1.combineReducers)({
        ui: (0, redux_1.combineReducers)({
            airMixingTool: AirMixingTool.reducer,
            airPowerTool: AirPowerTool.reducer,
            debugSettings: DebugSettings.reducer,
            advancedProductSearch: AdvancedProductSearch.reducer,
            coilProTool: CoilProTool.reducer,
            fanProTool: FanProTool.reducer,
            fanMotorProTool: FanMotorProTool.reducer,
            humidityConversionTool: HumidityConversionTool.reducer,
            effectiveClaims: EffectiveClaims.reducer,
            mainMenu: MainMenu.reducer,
            mainShell: MainShell.reducer,
            propertiesSelector: GenesysPropertiesSelector.reducer,
            psychrometricTool: PsychometricTool.reducer,
            usageStatistics: UsageStatistics.reducer,
            nevada: Nevada.reducer,
            debug: Debug.reducer,
            systemTypeValidation: SystemTypeValidation.reducer,
            productValidation: ProductValidation.reducer,
            rotorProductValidation: RotorProductValidation.reducer,
            productPropertySearch: ProductPropertySearch.reducer,
            systemTypePropertySearch: SystemTypePropertySearch.reducer,
            variantListing: VariantListing.reducer,
            systemCompare: SystemCompare.reducer,
            mlcUsageStatistics: MlcUsageStatistics.reducer,
            tandCAcceptanceStatus: TandCAcceptanceStatus.reducer,
            translationSearch: TranslationSearch.reducer,
            oilonTool: OilonTool.reducer
        }),
        queryProduct: GraphQLEntityState.reducerQueryProduct,
        queryUser: GraphQLEntityState.reducerQueryUser,
        accessToken: accessTokenReducer
    });
}
function accessTokenReducer(
// biome-ignore lint: -
state = "", action) {
    switch (action.type) {
        case "global-actions/USER_LOGGED_IN": {
            return action.accessToken;
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action.type);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map